// import PropTypes from "prop-types";
import styled, { createGlobalStyle } from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Modal as ModalReactBootstrap } from "react-bootstrap";

// Create global styles for the modal backdrop
const GlobalStyle = createGlobalStyle`
  .modal-backdrop.show {
    backdrop-filter: blur(3px);
    z-index: 1055;
  }
  .modal-backdrop {
    background-color: rgba(0, 0, 0, 0.7);
  }
`;

const StyledModal = styled(ModalReactBootstrap)`
  .modal-content {
    max-height: 90%;
    border: unset;
    padding: 0.5rem;
    background-color: ${({ theme }) => theme.surface};
    color: ${({ theme }) => theme.text};
    border-radius: 5px;
  }
  .modal-header {
    border: unset;
    background-color: ${({ theme }) => theme.surface};
    justify-content: space-between
  }
  .modal-footer {
    border: unset;
    background-color: ${({ theme }) => theme.surface};
  }
`;

const BtnClose = styled(FontAwesomeIcon)`
  font-size: 18px;
  cursor: pointer;
`;

const Modal = ({ children, handleClose, show, size, ...restProps }) => {
  return (
    <>
      <GlobalStyle />
      <StyledModal
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
        show={show}
        onHide={handleClose}
        enforceFocus={false}
        {...restProps}
      >
        {children}
      </StyledModal>
    </>
  );
};

Modal.Header = function ModalHeader({ children, handleClose, ...restProps }) {
  return (
    <ModalReactBootstrap.Header>
      {children}
      <BtnClose onClick={handleClose} icon={faTimes} />
    </ModalReactBootstrap.Header>
  );
};

Modal.Title = function ModalTitle({ children, ...restProps }) {
  return (
    <ModalReactBootstrap.Title id="contained-modal-title-vcenter">
      <h5 className="modal-title">{children}</h5>
    </ModalReactBootstrap.Title>
  );
};

Modal.Body = function ModalBody({ children, ...restProps }) {
  return <ModalReactBootstrap.Body>{children}</ModalReactBootstrap.Body>;
};

export default Modal;
